import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPieChart } = FiIcons;

const ComplianceStatusBreakdown = ({ records = [] }) => {
  const statuses = ['Compliant', 'In Progress', 'At Risk', 'Overdue', 'Not Started'];
  const counts = statuses.map(s => records.filter(r => r?.complianceStatus === s).length);
  const colors = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#94a3b8'];
  const total = counts.reduce((a, b) => a + b, 0);

  const option = {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    series: [{
      type: 'pie', radius: ['50%', '75%'],
      data: statuses.map((s, i) => ({ name: s, value: counts[i], itemStyle: { color: colors[i] } })),
      label: { show: false },
      emphasis: { label: { show: true, fontSize: 13, fontWeight: 'bold' } }
    }]
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiPieChart} className="text-teal-500" />
        <h3 className="text-sm font-semibold text-slate-700">Status Breakdown</h3>
      </div>
      <ReactECharts option={option} style={{ height: 180 }} />
      <div className="mt-3 space-y-1.5">
        {statuses.map((s, i) => (
          <div key={s} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: colors[i] }} />
              <span className="text-slate-600">{s}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-bold text-slate-700">{counts[i]}</span>
              <span className="text-slate-400">({total > 0 ? Math.round(counts[i] / total * 100) : 0}%)</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplianceStatusBreakdown;